import getSubscriptionStatusLabel from '../helpers/getSubscriptionStatusLabel';
import type { SubscriptionBadgeProps } from '../types';
import { StatusBadge, StatusDot } from './styled';

const SubscriptionBadge = ({ status }: SubscriptionBadgeProps) => (
    <StatusBadge $status={status}>
        <StatusDot $status={status} />
        {getSubscriptionStatusLabel({ status })}
    </StatusBadge>
);

export default SubscriptionBadge;
